<template>
  <!-- Language Buttons -->
  <div class="flex flex-row justify-end my-1.5">
    <div class="md:w-5/12 flex flex-row-reverse">
      <span
        @click="onLanguageChange"
        class="flex text-white mx-2 focus:ring-0 focus:outline-none focus:ring-pink-300 rounded-lg text-md w-auto sm:w-auto px-3 py-1 text-center cursor-pointer border border-gray-100 w-btn absloute z-20"
      >
        

        <template v-if="lang == 'en'"> العربية </template>
        <template v-if="lang == 'ar'"> English</template>
        <!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 ml-1"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802"
          />
        </svg> -->
      </span>
    </div>
  </div>

  <!-- End Of Language Buttons -->
</template>

<script>
import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    return {
      lang: "ar",
      store: useAuthStore(),
    };
  },
  //get the default land
  mounted() {
    this.lang = this.store.getLandingPageLanguage;
  },
  methods: {
    onLanguageChange() {
      this.store.changeLanguage();
      this.lang = this.store.getLandingPageLanguage;
    },
  },
};
</script>

<style></style>
